import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  skuCode: {
    type: "select",
    name: "skuCode",
    label: "SKU Code",
    maxLength: 20,
    required: true,
    xs: 3,
  },
  skuDescription: {
    type: "text",
    name:"skuDescription",
    label: "SKU Description",
    disabled: true,
    xs:3
  },
  quantity: {
    type: "number",
    name: "quantity",
    label: "Quantity",
    maxLength: 20,
    required: true,
    xs: 3,
    errorMsg: "Quantity must be integer",
    errorMsg2: "Quantity must be greater than 0",
  },
};

const { skuCode, skuDescription, quantity } = formField;

export const formRender = [[skuCode, skuDescription, quantity]];

export const initialValues = getInitialValues(formField);

export const kitSKUDetailValidation = Yup.object().shape({
  [skuCode.name]: Yup.string().nullable().max(skuCode.maxLength),
  [quantity.name]: Yup.number().min(0).integer(quantity.errorMsg).positive(quantity.errorMsg2),
  [skuDescription.name]: Yup.string().nullable(),
});
